module.exports = __webpack_public_path__ + "img/Owner.36cf1f87.svg";